import { createReducer } from '@reduxjs/toolkit';

import { QLog, QTask } from '@qwealth/qdata';

import {
  createQBoardCallLogActivity,
  deleteQBoardCallLogActivity,
  deleteQBoardTaskActivity,
  resetQBoardActivitiesData,
  setActivitiesLoading,
  updateQBoardCallLogActivity,
  updateQBoardCallLogs,
  updateQBoardTasks,
} from '../actions/activities';
interface State {
  tasks: Array<QTask>;
  callLogs: Array<QLog>;
  isLoading: boolean;
}

const initialState: State = {
  tasks: [],
  callLogs: [],
  isLoading: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(setActivitiesLoading, (state, action) => ({
    ...state,
    isLoading: action.payload,
  }));

  builder.addCase(updateQBoardTasks, (state, action) => {
    if (!action.payload) return state;
    state.tasks = [...action.payload];
  });

  builder.addCase(deleteQBoardCallLogActivity, (state, action) => {
    if (!action.payload) return state;
    state.callLogs = state.callLogs.filter(log => log.uuid !== action.payload);
  });

  builder.addCase(deleteQBoardTaskActivity, (state, action) => {
    if (!action.payload) return state;
    state.tasks = state.tasks.filter(task => !action.payload.some(payloadItem => payloadItem.id === task.id));
  });

  builder.addCase(createQBoardCallLogActivity, (state, action) => {
    if (!action.payload) return state;
    state.callLogs = [...state.callLogs, action.payload];
  });

  builder.addCase(updateQBoardCallLogActivity, (state, action) => {
    if (!action.payload) return state;
    state.callLogs = state.callLogs.map(log => (log.uuid === action.payload.uuid ? action.payload : log));
  });

  builder.addCase(updateQBoardCallLogs, (state, action) => {
    if (!action.payload) return state;
    state.callLogs = [...action.payload];
  });

  builder.addCase(resetQBoardActivitiesData, (state, action) => {
    if (!action.payload) return state;
    return { ...initialState };
  });
});
